<template>
    <div>
        <navbar></navbar>
        <img src="../assets/img/findworka-talents.png" class="__climgrtl"/>
        <div class="container">
            <p class="__portpnew">One Node.js Engineer, Big Impact for Klak’s Financial Toolkit</p>
            <p class="__headin">The Challenge</p>
            <p class="__meetdname">Klak’s backend team was overstretched just as the fintech needed to refactor its payment engine and design new analytics APIs. They required a Node.js specialist with strong fintech chops—yesterday.</p>
            
            <p class="__headin">The Solution</p>
            <p class="__meetdname">Within a week Findworka placed a Node.js engineer experienced in micro-services, Postgres, MongoDB and third-party financial APIs. By week two he was contributing to production.</p>

            <p class="__headin">Services Offered</p>
            <ul class="__portp2new">
                <li>Needs discovery</li>
                <li>Precision matchmaking </li>
                <li>Documentation & onboarding</li>
                <li>Continuous engagement oversight</li>
            </ul>
            
            <p class="__headin">Impact & Results (tile metrics)</p>
            <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__card1">
                        <p class="__meetdname"><span class="__namp">Sprint Velocity</span></p>
                        <p class="__meetdname">+25 %</p>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__card1">
                        <p class="__meetdname"><span class="__namp">Security Hardening</span></p>
                        <p class="__meetdname">Improved protocols</p>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__card1">
                        <p class="__meetdname"><span class="__namp">Documentation Quality</span></p>
                        <p class="__meetdname">Comprehensive</p>
                    </div>
                </div>
            </div><br>

            <p class="__meetdname">The engineer refactored Klak’s payment engine, improved data-security layers and boosted cross-team collaboration—prompting Klak to extend the engagement beyond the initial three months.</p>

            <p class="__headin">Tech Stack Deployed</p>
            <ul class="__portp2new">
                <li>Node.js</li>
                <li>PostgreSQL</li>
                <li>MongoDB</li>
                <li>Docker</li>
                <li>Jenkins</li>
            </ul>

            <p class="__headin">Client Testimonial</p>
            <p class="__meetdname">“The backend engineer from Findworka brought the exact kind of energy, precision, and thinking we needed. He wasn’t just building features—he was helping us think about the bigger picture.” <span class="__namp"><i> — Engineering Lead, Klak Technologies</i></span></p>

            <div class="row">
                <div class="col-xl-2 col-lg-2 col-md-2 col-12"></div>
                <div class="col-xl-8 col-lg-8 col-md-8 col-12">
                    <div class="text-center">
                        <p class="__hvsip">Need top-tier developers reliably and quickly?</p>
                        <p class="__meetdname">Tell us about the roles you’re hiring for, and receive pre-vetted profiles in under 72 hours. Whether you’re looking for individuals or building a team, you’ve come to the right place.</p>
                        <router-link to="/hire" class="btn __viewsite">Get Started Here </router-link>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-2 col-12"></div>
            </div>

            <div class="__whitespace"></div>
        </div>
    </div>
</template>


<script>
import navbar from '../components/navbar';

export default {
    components: { navbar },
    data(){
        return{}
    },
}
</script>

<style scoped>
@import '../assets/css/portfolio';
</style>


// WEBPACK FOOTER //
// src/components/talentklak.vue